import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { WindowState } from '@progress/kendo-angular-dialog';
import { FormGroup } from '@angular/forms';
import { User } from '@app/core/models';


@Component({
  selector: 'create-edit-window',
  template: ``,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }
  `],
  providers: [ DatasourceService ] //Siempre hay que ponerlo en la clase que lo implemente.
})
export class CreateEditWindowComponent implements OnInit {

  //Inputs

  @Input() opened = false;  

  @Input() table: string = 'TABLE';

  @Input() label: string = 'LABEL';

  //Variables
  
  protected currentUser: User;
  
  protected windowState: WindowState = 'default';

  protected mode = 'CREATE';

  protected form: FormGroup = null;  

  //Eventos

  // @Output() cancel: EventEmitter<any> = new EventEmitter();

  @Output() save: EventEmitter<{mode:string, dataItem:any}> = new EventEmitter();    

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {    

    this.authService.currentUser.subscribe(x => this.currentUser = x);

  }

  public getObjectString(dataItem: any): string {

    return [
      `Id: '${dataItem.id}'`
    ].join('\n')

  };

  protected getFormGroup(user: User, dataItem?: any): FormGroup {

    return new FormGroup({});

  };

  protected getData(formGroup: FormGroup): Object {

    return formGroup.value;

  };  

  public create(): void {

    this.mode = 'CREATE';
    this.opened = true;
    this.form = this.getFormGroup(this.currentUser)
            
  }

  public edit(dataItem: any, rowIndex: number = null): void {

    this.mode = 'EDIT';
    this.opened = true;
    this.form = this.getFormGroup(this.currentUser, dataItem)

    this.service.getById(this.table, dataItem.id, false).subscribe((res: any) => {

      console.log(res)
      this.form = this.getFormGroup(this.currentUser, res)

    });
  
  }   

  public delete(dataItem: any): void {
    
    this.mode = 'DELETE';
    this.opened = false;

    this.alertService.confirmDelete(this.getObjectString(dataItem), () => {

      this.onDelete(dataItem)

    });
    
  }

  public onDelete(data: any): void {
    
    console.log('data', data)

    this.service.removeRow(this.table, data) 
      .subscribe(
        (res) => {
          console.log("DELETE Request is successful: ", this.table, data);
          console.log("mode = " + this.mode);
          this.save.emit({mode: this.mode, dataItem: res.data[0]});
          this.opened = false;
        },
        (fail) => {        
          console.log("Error", fail);
          // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      ); 

  }

  public onSave(): void {
    
    let data = this.getData(this.form);
    console.log('data', data)

    if(this.mode == 'CREATE'){
      this.service.addRow(this.table, data) 
        .subscribe(
          (res) => {
            console.log("POST Request is successful: ", this.table, data);
            console.log("mode = " + this.mode);
            this.save.emit({mode: this.mode, dataItem: res.data[0]});
            this.opened = false;
          },
          (fail) => {        
            console.log("Error", fail);
            // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
          }
        ); 
    }
    else {
      this.service.updateRow(this.table, data) 
        .subscribe(
          (res) => {
            console.log("PUT Request is successful: ", this.table, data);
            console.log("mode = " + this.mode);
            this.save.emit({mode: this.mode, dataItem: res.data[0]});
            this.opened = false;
          },
          (fail) => {        
            console.log("Error", fail);
            // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
          }
        ); 
    }

  }

  // public cleanForm(formGroup: FormGroup) {
  //   Object.keys(formGroup.controls).forEach((key) => formGroup.get(key).setValue(formGroup.get(key).value.trim()));
  // }
  
  get f() { 
    
    return this.form.controls; 
  
  }

  public onClose(): void {

    this.opened = false;    

  }

  public onCancel(): void {

    this.opened = false;    

  }

  ngOnInit() {

    this.form = this.getFormGroup(this.currentUser);
    
  }

}
